__turbopack_context__.v({
  "overlay": "index-module-scss-module__UDCtca__overlay",
  "overlayHeader": "index-module-scss-module__UDCtca__overlayHeader",
  "title": "index-module-scss-module__UDCtca__title",
});
